"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = _interopRequireDefault(require("./config"));
var _styledPassword = require("./styled-password");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var passwordModalHintsConfig = _config["default"].passwordModalHintsConfig;
var propTypes = {
  onClose: _propTypes["default"].func,
  isOpen: _propTypes["default"].bool
};
var defaultProps = {
  onClose: undefined,
  isOpen: false
};
function PasswordModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledModal, {
    open: isOpen,
    onClose: onClose,
    title: "Tips for creating a secure password",
    hasPadding: true,
    srLabelCloseButton: "Close modal"
  }, /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledModalParagraph, {
    id: "passwordHintText",
    size: "1",
    type: "paragraph"
  }, /*#__PURE__*/_react["default"].createElement("ul", null, passwordModalHintsConfig.map(function (hint) {
    return /*#__PURE__*/_react["default"].createElement(_styledPassword.StyledModalHintListItem, {
      key: hint
    }, hint);
  }))));
}
PasswordModal.propTypes = propTypes;
PasswordModal.defaultProps = defaultProps;
var _default = exports["default"] = PasswordModal;